/**
 * Formatage des montants monétaires VVS — porté à l'identique depuis
 * apps/web/lib/format.ts (aucune dépendance Next.js, port verbatim).
 *
 * XOF n'a aucune décimale (VVS_MODELE_DONNEES.md §4.2.1 : les montants sont
 * exposés en entiers `amountMinor`, avec `minorUnit = 0` pour XOF — il n'y a
 * donc pas de distinction "majeure/mineure" à gérer, `amountMinor` est déjà
 * le montant en francs CFA).
 */

const NBSP = " ";

const XOF_GROUPING_FORMATTER = new Intl.NumberFormat("fr-FR", {
  style: "decimal",
  maximumFractionDigits: 0,
  minimumFractionDigits: 0,
});

/**
 * Formate un montant XOF (entier, sans décimale) en chaîne lisible à la
 * française avec espace insécable comme séparateur de milliers.
 *
 * @example formatXOF(14000) // "14 000 FCFA" (espaces insécables U+00A0)
 */
export function formatXOF(amountMinor: number): string {
  if (!Number.isFinite(amountMinor)) {
    throw new TypeError(`formatXOF: montant invalide (${String(amountMinor)})`);
  }

  const rounded = Math.round(amountMinor);
  // Intl.NumberFormat("fr-FR") regroupe les milliers avec l'espace fine
  // insécable (U+202F) selon l'ICU utilisée ; on la normalise en espace
  // insécable classique (U+00A0) pour rester cohérent avec le reste de la
  // chaîne et éviter toute dépendance à la version d'ICU du runtime.
  const grouped = XOF_GROUPING_FORMATTER.format(rounded).replace(/[   ]/g, NBSP);

  return `${grouped}${NBSP}FCFA`;
}
